import { render, staticRenderFns } from "./vEllipsisLoader.vue?vue&type=template&id=53774dc9&"
import script from "./vEllipsisLoader.vue?vue&type=script&lang=js&"
export * from "./vEllipsisLoader.vue?vue&type=script&lang=js&"
import style0 from "./vEllipsisLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports